import type { AccountResponse } from '../../sharedTypes';

export const USER = {
  RECEIVE_USER_STATUS: 'user/receive_user_status',
  RECEIVE_USER_ERROR: 'user/receive_user_error',
  FETCH_USER_AVATAR_REQUEST: 'user/fetch_user_avatar_request',
  FETCH_USER_AVATAR_SUCCESS: 'user/fetch_user_avatar_success',
  FETCH_USER_AVATAR_FAILURE: 'user/fetch_user_avatar_failure',
  REQUEST_ACCOUNT_PAST_DUE: 'user/request_account_past_due',
  RECEIVE_ACCOUNT_PAST_DUE_SUCCESS: 'user/receive_account_past_due_success',
  RECEIVE_ACCOUNT_PAST_DUE_ERROR: 'user/receive_account_past_due_error',
  REQUEST_USER_STATUS: 'user/request_user_status',
};

export type ReceiveUserStatusAction = {
  type: typeof USER.RECEIVE_USER_STATUS;
  payload: AccountResponse;
};

export type ReceiveUserErrorAction = {
  type: typeof USER.RECEIVE_USER_ERROR;
};

export type FetchUserAvatarRequest = {
  type: typeof USER.FETCH_USER_AVATAR_REQUEST;
};

export type FetchUserAvatarSuccess = {
  type: typeof USER.FETCH_USER_AVATAR_SUCCESS;
  userAvatarUrl: string;
};

export type FetchUserAvatarFailure = {
  type: typeof USER.FETCH_USER_AVATAR_FAILURE;
  error: string;
};

export type fetchUserStatusRequest = {
  type: typeof USER.REQUEST_USER_STATUS;
};

export type fetchUserStatusSuccess = {
  type: typeof USER.RECEIVE_USER_STATUS;
  userStatus: object;
};

export type RequestIsAccountPastDueAction = {
  type: typeof USER.REQUEST_ACCOUNT_PAST_DUE;
};

export type ReceiveIsAccountPastDueAction = {
  type: typeof USER.RECEIVE_ACCOUNT_PAST_DUE_SUCCESS;
  isAccountPastDue: boolean;
};

export type ReceiveIsAccountPastDueActionError = {
  type: typeof USER.RECEIVE_ACCOUNT_PAST_DUE_ERROR;
  error: string;
};

export type UserAction =
  | ReceiveUserStatusAction
  | ReceiveUserErrorAction
  | FetchUserAvatarRequest
  | FetchUserAvatarSuccess
  | FetchUserAvatarFailure
  | fetchUserStatusRequest
  | fetchUserStatusSuccess
  | RequestIsAccountPastDueAction
  | ReceiveIsAccountPastDueAction
  | ReceiveIsAccountPastDueActionError;

export function receiveUserStatus(payload: AccountResponse): ReceiveUserStatusAction {
  return {
    type: USER.RECEIVE_USER_STATUS,
    payload,
  };
}

export function receiveUserError(): ReceiveUserErrorAction {
  return {
    type: USER.RECEIVE_USER_ERROR,
  };
}

export function fetchUserAvatarRequest(): FetchUserAvatarRequest {
  return {
    type: USER.FETCH_USER_AVATAR_REQUEST,
  };
}

export function fetchUserAvatarSuccess(userAvatarUrl: string): FetchUserAvatarSuccess {
  return {
    type: USER.FETCH_USER_AVATAR_SUCCESS,
    userAvatarUrl,
  };
}

export function fetchUserAvatarError(error: string): FetchUserAvatarFailure {
  return {
    type: USER.FETCH_USER_AVATAR_FAILURE,
    error,
  };
}

export function requestIsAccountPastDue(): RequestIsAccountPastDueAction {
  return {
    type: USER.REQUEST_ACCOUNT_PAST_DUE,
  };
}

export function receiveIsAccountPastDue(isAccountPastDue: boolean): ReceiveIsAccountPastDueAction {
  return {
    type: USER.RECEIVE_ACCOUNT_PAST_DUE_SUCCESS,
    isAccountPastDue,
  };
}

export function receiveIsAccountPastDueError(error: string): ReceiveIsAccountPastDueActionError {
  return {
    type: USER.RECEIVE_ACCOUNT_PAST_DUE_ERROR,
    error,
  };
}
